import { reactive, readonly } from 'vue';

const DEFAULT_OPTIONS = Object.freeze({
    title: 'Подтвердите действие',
    message: '',
    confirmLabel: 'Подтвердить',
    cancelLabel: 'Отмена',
    tone: 'primary',
});

const state = reactive({ isOpen: false, options: { ...DEFAULT_OPTIONS } });
let resolvePending = null;

const settle = (isConfirmed) => {
    state.isOpen = false;
    resolvePending?.(isConfirmed);
    resolvePending = null;
};

/**
 * Замена window.confirm: открывает глобальный ConfirmHost и резолвится true/false.
 * Повторный вызов при открытом диалоге отменяет предыдущий запрос.
 *
 * @param {Partial<typeof DEFAULT_OPTIONS>} options
 * @returns {Promise<boolean>}
 */
export const confirmAction = (options = {}) => {
    if (resolvePending) settle(false);

    state.options = { ...DEFAULT_OPTIONS, ...options };
    state.isOpen = true;

    return new Promise((resolve) => {
        resolvePending = resolve;
    });
};

export const useConfirm = () => ({
    state: readonly(state),
    confirm: () => settle(true),
    cancel: () => settle(false),
});
